import { AfterViewChecked, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

/**
 * Shared list/detail switch inside the app-wide Workspace.
 * New / View / Edit occupy the whole business area. The list stays mounted
 * at the same size underneath, preserving its state and scroll position.
 * The app-shell Command Bar keeps its existing placement.
 */
@Component({
  selector: 'app-workspace-master-detail',
  templateUrl: './workspace-master-detail.component.html',
  styleUrls: ['./workspace-master-detail.component.css'],
})
export class WorkspaceMasterDetailComponent implements OnChanges, AfterViewChecked {
  @Input() detailOpen = false;

  @ViewChild('master') private master?: ElementRef<HTMLElement>;
  @ViewChild('detail') private detail?: ElementRef<HTMLElement>;
  private returnFocus: HTMLElement | null = null;
  private focusPending = false;

  ngOnChanges(changes: SimpleChanges): void {
    const change = changes['detailOpen'];
    if (!change) return;
    if (this.detailOpen) {
      const master = this.master?.nativeElement;
      const active = master?.ownerDocument.activeElement;
      this.returnFocus = active instanceof HTMLElement && master?.contains(active) ? active : null;
    }
    this.focusPending = this.detailOpen || !change.firstChange;
  }

  ngAfterViewChecked(): void {
    if (!this.focusPending) return;
    this.focusPending = false;
    // The projected route and inert bindings must update before moving focus.
    // Returning must not scroll the retained collection.
    const target = this.detailOpen
      ? this.detail?.nativeElement
      : this.returnFocus?.isConnected ? this.returnFocus : this.master?.nativeElement;
    target?.focus({ preventScroll: true });
    if (!this.detailOpen) this.returnFocus = null;
  }
}
